export const AppConstants = {
    SupportEmail: "StoneXHedge@stonex.com",
    SupportPhone: "209-588-7399"
}